module.exports = __webpack_public_path__ + "img/bg_cloud.133ea8bf.jpg";